import { render, staticRenderFns } from "./RecentSurveysTab.vue?vue&type=template&id=7a0f3498&scoped=true&"
import script from "./RecentSurveysTab.vue?vue&type=script&lang=js&"
export * from "./RecentSurveysTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f3498",
  null
  
)

export default component.exports